/* METTA — header arrows for the grid tile carousel. Native overflow scroll
   does the moving (so trackpads and touch work for free); the arrows step one
   tile and disable at either end. */
if (!customElements.get('metta-tile-carousel')) {
  customElements.define('metta-tile-carousel', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.metta-tile-carousel__viewport');
      this.track = this.querySelector('.metta-tile-carousel__track');
      const nav = this.closest('.grid.section')?.querySelector('.metta-tile-carousel__nav');
      this.prev = nav?.querySelector('[data-prev]');
      this.next = nav?.querySelector('[data-next]');
      this.controller = new AbortController();
      const on = (target, event, fn) => target?.addEventListener(event, fn, {signal: this.controller.signal});

      on(this.prev, 'click', () => this.step(-1));
      on(this.next, 'click', () => this.step(1));
      on(this.viewport, 'scroll', () => this.update(), {passive: true});
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.viewport);
      this.update();
      this.preload();
    }

    disconnectedCallback() {
      this.controller.abort();
      this.resize?.disconnect();
      this.near?.disconnect();
    }

    // Photos ahead of time (30 Oct 2026, Pétur: "Frontpage flokkar preload").
    // Lazy, each started near the screen and faded in as the row arrived,
    // and the tiles to the right only once the row was scrolled. Now all of
    // them, hidden ones too, start loading a screen and a half before the
    // row comes into view: at low priority, so the hero and the shelves
    // above keep the bandwidth.
    preload() {
      const images = Array.from(this.querySelectorAll('img[loading="lazy"]'));
      if (!images.length || typeof IntersectionObserver !== 'function') return;
      this.near = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.near.disconnect();
        images.forEach((image) => {
          image.fetchPriority = 'low';
          image.loading = 'eager';
        });
      }, {rootMargin: '150% 0px'});
      this.near.observe(this);
    }

    step(direction) {
      // Target a tile's own offset rather than scrolling by a distance, so the
      // destination is always a snap point and snapping never fights the arrow.
      const tiles = Array.from(this.track.children);
      if (!tiles.length) return;
      const origin = tiles[0].offsetLeft;
      const offsets = tiles.map((tile) => tile.offsetLeft - origin);
      const current = offsets.reduce((best, offset, index) =>
        Math.abs(offset - this.viewport.scrollLeft) < Math.abs(offsets[best] - this.viewport.scrollLeft) ? index : best, 0);
      const target = offsets[Math.min(Math.max(current + direction, 0), offsets.length - 1)];
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      const smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.viewport.scrollTo({left: Math.min(target, max), behavior: smooth ? 'smooth' : 'auto'});
    }

    update() {
      const {scrollLeft, scrollWidth, clientWidth} = this.viewport;
      const atStart = scrollLeft <= 1;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;
      [[this.prev, atStart], [this.next, atEnd]].forEach(([button, off]) => {
        if (!button) return;
        button.disabled = off;
        button.classList.toggle('swiper-button-disabled', off);
      });
    }
  });
}
